import React from 'react'

import cx from "classnames";
import styles from "./DeleteMediaModalContent.module.scss";
import Text from "../../../../components/Text";
import Button from "../../../../components/Button";
import {useTranslation} from "react-i18next";
import {useGlobalContext} from "../../../../contexts/globalContext";
import {Media} from "../../../../types/Media";
import {useDeleteData} from "../../../../hooks/useDeleteData";

const DeleteMediaModalContent: React.FC<{media: Media, onSubmit: () => void}> = ({media, onSubmit}) => {
    const { t } = useTranslation(['settings'])
    const { closeModal, showToast } = useGlobalContext()
    const { submit } = useDeleteData('media', media.id)

    const handleSubmit = () => {
        submit().then((res) => {
            if (res.status === 204) {
                closeModal()
                showToast('top-right', 'success', t('media.delete_modal.success'))
            } else {
                showToast('top-right', 'error', t('media.delete_modal.error'))
            }
            onSubmit()
        })
    }

    return (
        <div className={cx(styles['modal-wrapper'])}>
            <Text>{t('media.delete_modal.sub_heading', {media_name: media.name})}</Text>
            <Button
                hierarchy={'primary'}
                text={t('media.delete_modal.delete')}
                fn={() => handleSubmit()} classes={'w-100 mx-4 my-2'}
            />
            <Button
                hierarchy={'secondary'}
                text={t('common.abort')}
                fn={() => closeModal()} classes={'w-100 mx-4 my-2'}
            />
        </div>
    )
}

export default DeleteMediaModalContent
